import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Department, useAdminDepartmentsQuery } from "@common/utils/graphql";
import { useState } from "react";
import { DataTable } from "@common/components/Table/DataTable";
import { FullPageLoader } from "@common/components/Loading/FullPageLoading";
import { departmentsTableColumns } from "./columns";
import { CreateDepartmentSheet } from "./CreateDepartmentSheet";
import { ViewDepartmentSheet } from "./ViewDepartmentSheet";
import { Card } from "@/components/ui/card";

export const DepartmentsTab = () => {
  const [searchText, setSearchText] = useState("");
  const [isCreateDeptOpen, setIsCreateDeptOpen] = useState(false);
  const [viewDepartmentId, setViewDepartmentId] = useState<number | undefined>(
    undefined,
  );

  const openCreateDepartment = () => setIsCreateDeptOpen(true);
  const closeCreateDepartment = () => setIsCreateDeptOpen(false);
  const resetDepartment = () => {
    setViewDepartmentId(undefined);
    refetchDepartments();
  };

  const {
    loading: loadingDepartments,
    data: departmentsDataRaw,
    refetch: refetchDepartments,
  } = useAdminDepartmentsQuery({
    fetchPolicy: "cache-and-network",
  });

  const onSheetClose = () => {
    closeCreateDepartment();
    refetchDepartments();
  };

  const departments =
    departmentsDataRaw?.departments?.__typename !== "QueryDepartmentsSuccess"
      ? []
      : departmentsDataRaw.departments.data.departments.filter((d) =>
          d.name.toLowerCase().includes(searchText.toLowerCase()),
        );

  const viewDepartment = departments.find(
    (d) => d.id === viewDepartmentId,
  ) as Department;

  const header = (
    <div className="flex gap-5 pt-5">
      <Input
        className="w-full"
        type="search"
        placeholder="Search"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
      <Button onClick={openCreateDepartment}>Create Department</Button>
    </div>
  );

  const table = (
    <Card className="mt-5">
      <DataTable
        columns={departmentsTableColumns}
        data={departments as Department[]}
        onClick={(row) => setViewDepartmentId(row.original.id)}
      />
    </Card>
  );

  const sheets = (
    <>
      <CreateDepartmentSheet
        isOpen={isCreateDeptOpen}
        onClose={closeCreateDepartment}
        onBack={onSheetClose}
      />
      {viewDepartment && (
        <ViewDepartmentSheet
          department={viewDepartment}
          onClose={resetDepartment}
          refetchDepartments={refetchDepartments}
          isOpen
        />
      )}
    </>
  );

  return (
    <>
      {header}
      {loadingDepartments && departments.length === 0 ? (
        <FullPageLoader />
      ) : (
        table
      )}
      {sheets}
    </>
  );
};
